/**
 * 플랫폼 감지 핵심 기능 - Tauri 기본 API 활용
 */ // Tauri 플러그인 동적 import (웹 환경에서도 동작하도록)
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var tauriOs = null;
// Tauri OS 플러그인 초기화
export var initTauriOs = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var module, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof window !== 'undefined' && window.__TAURI__)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import('@tauri-apps/plugin-os')
                    ];
                case 2:
                    module = _state.sent();
                    tauriOs = module;
                    return [
                        2,
                        true
                    ];
                case 3:
                    e = _state.sent();
                    console.warn('[PlatformDetection] Tauri OS plugin not available:', e);
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function initTauriOs() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 현재 플랫폼 정보를 반환 (Tauri 기본 API 활용)
 */ export var getPlatformInfo = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var isTauri, tauriAvailable, platform, arch, isMobile, isDesktop, e, isMobile1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // VSCode WebView 감지
                    if (typeof window !== 'undefined' && window.acquireVsCodeApi !== 'undefined') {
                        return [
                            2,
                            {
                                isTauri: false,
                                isMobile: false,
                                isDesktop: true,
                                isWeb: false,
                                isVSCode: true,
                                isJetBrains: false,
                                isElectron: false,
                                platform: 'vscode'
                            }
                        ];
                    }
                    // JetBrains IDE 감지
                    if (typeof window !== 'undefined' && window.jetBrainsApi !== 'undefined') {
                        return [
                            2,
                            {
                                isTauri: false,
                                isMobile: false,
                                isDesktop: true,
                                isWeb: false,
                                isVSCode: false,
                                isJetBrains: true,
                                isElectron: false,
                                platform: 'jetbrains'
                            }
                        ];
                    }
                    // Electron 감지
                    if (typeof window !== 'undefined' && (window.electron !== 'undefined' || typeof process !== 'undefined' && process.versions && process.versions.electron)) {
                        return [
                            2,
                            {
                                isTauri: false,
                                isMobile: false,
                                isDesktop: true,
                                isWeb: false,
                                isVSCode: false,
                                isJetBrains: false,
                                isElectron: true,
                                platform: 'electron'
                            }
                        ];
                    }
                    // Tauri 환경 감지
                    isTauri = typeof window !== 'undefined' && window.__TAURI__;
                    if (!isTauri) {
                        // 웹 환경
                        return [
                            2,
                            {
                                isTauri: false,
                                isMobile: false,
                                isDesktop: false,
                                isWeb: true,
                                isVSCode: false,
                                isJetBrains: false,
                                isElectron: false,
                                platform: 'web'
                            }
                        ];
                    }
                    return [
                        4,
                        initTauriOs()
                    ];
                case 1:
                    tauriAvailable = _state.sent();
                    if (!(tauriAvailable && tauriOs)) return [
                        3,
                        6
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        tauriOs.platform()
                    ];
                case 3:
                    platform = _state.sent();
                    return [
                        4,
                        tauriOs.arch()
                    ];
                case 4:
                    arch = _state.sent();
                    // 모바일 플랫폼 판단 (ios, android)
                    isMobile = platform === 'ios' || platform === 'android';
                    isDesktop = !isMobile;
                    return [
                        2,
                        {
                            isTauri: true,
                            isMobile: isMobile,
                            isDesktop: isDesktop,
                            isWeb: false,
                            isVSCode: false,
                            isJetBrains: false,
                            isElectron: false,
                            platform: isMobile ? 'tauri-mobile' : 'tauri-desktop',
                            os: platform,
                            arch: arch
                        }
                    ];
                case 5:
                    e = _state.sent();
                    console.error('[PlatformDetection] Error getting Tauri platform info:', e);
                    return [
                        3,
                        6
                    ];
                case 6:
                    // Tauri API 사용 불가 시 폴백 (레거시 방식)
                    console.warn('[PlatformDetection] Falling back to legacy detection');
                    isMobile1 = typeof window !== 'undefined' && (window.__TAURI_PLATFORM__ === 'android' || window.__TAURI_PLATFORM__ === 'ios' || typeof navigator !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent));
                    return [
                        2,
                        {
                            isTauri: true,
                            isMobile: isMobile1,
                            isDesktop: !isMobile1,
                            isWeb: false,
                            isVSCode: false,
                            isJetBrains: false,
                            isElectron: false,
                            platform: isMobile1 ? 'tauri-mobile' : 'tauri-desktop'
                        }
                    ];
            }
        });
    });
    return function getPlatformInfo() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 동기식 플랫폼 정보 반환 (캐시된 값 사용)
 * 초기 로드 시 getPlatformInfo()를 한 번 호출 후 이 함수 사용
 */ var cachedPlatformInfo = null;
export var getPlatformInfoSync = function() {
    if (cachedPlatformInfo) {
        return cachedPlatformInfo;
    }
    // VSCode WebView 감지
    if (typeof window !== 'undefined' && window.acquireVsCodeApi !== 'undefined') {
        return {
            isTauri: false,
            isMobile: false,
            isDesktop: true,
            isWeb: false,
            isVSCode: true,
            isJetBrains: false,
            isElectron: false,
            platform: 'vscode'
        };
    }
    // JetBrains IDE 감지
    if (typeof window !== 'undefined' && window.jetBrainsApi !== 'undefined') {
        return {
            isTauri: false,
            isMobile: false,
            isDesktop: true,
            isWeb: false,
            isVSCode: false,
            isJetBrains: true,
            isElectron: false,
            platform: 'jetbrains'
        };
    }
    // Electron 감지
    if (typeof window !== 'undefined' && (window.electron !== 'undefined' || typeof process !== 'undefined' && process.versions && process.versions.electron)) {
        return {
            isTauri: false,
            isMobile: false,
            isDesktop: true,
            isWeb: false,
            isVSCode: false,
            isJetBrains: false,
            isElectron: true,
            platform: 'electron'
        };
    }
    // 캐시가 없으면 동기식 폴백 사용
    var isTauri = typeof window !== 'undefined' && window.__TAURI__;
    if (!isTauri) {
        return {
            isTauri: false,
            isMobile: false,
            isDesktop: false,
            isWeb: true,
            isVSCode: false,
            isJetBrains: false,
            isElectron: false,
            platform: 'web'
        };
    }
    // 레거시 방식으로 판단
    var isMobile = typeof window !== 'undefined' && (window.__TAURI_PLATFORM__ === 'android' || window.__TAURI_PLATFORM__ === 'ios' || typeof navigator !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent));
    return {
        isTauri: true,
        isMobile: isMobile,
        isDesktop: !isMobile,
        isWeb: false,
        isVSCode: false,
        isJetBrains: false,
        isElectron: false,
        platform: isMobile ? 'tauri-mobile' : 'tauri-desktop'
    };
};
/**
 * 플랫폼 정보 캐시 초기화
 */ export var initPlatformCache = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getPlatformInfo()
                    ];
                case 1:
                    cachedPlatformInfo = _state.sent();
                    return [
                        2,
                        cachedPlatformInfo
                    ];
            }
        });
    });
    return function initPlatformCache() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 특정 플랫폼인지 확인하는 헬퍼 함수
 */ export var isPlatform = function(platform) {
    var info = getPlatformInfoSync();
    return info.platform === platform;
};
/**
 * VSCode 환경인지 확인 (레거시 호환성)
 */ export var isVSCodeEnvironment = function() {
    var info = getPlatformInfoSync();
    return info.isVSCode;
};
/**
 * 플랫폼 감지 함수 (레거시 호환성)
 */ export var detectPlatform = function() {
    var info = getPlatformInfoSync();
    return info.platform;
};
// 앱 시작 시 플랫폼 캐시 초기화 권장
// Note: 이 초기화는 빌드 시 실행되지 않도록 런타임에서만 실행
if (typeof globalThis !== 'undefined' && typeof window !== 'undefined' && globalThis === window) {
    // 브라우저 환경에서만 초기화
    initPlatformCache().catch(function(e) {
        console.warn('[PlatformDetection] Failed to initialize platform cache:', e);
    });
}
